<template>
  <div style="height: 100%">
    <div style="height: 100%" ref="fadeWhenModelOpen">
    <div style="height:50px;" class="comm-settings-top-nav">
      <div class="col-md-12 h-100 justify-content-start p-0">
        <nav aria-label="breadcrumb" class="h-100">
          <ol class="breadcrumb comm-settings-top-nav m-0 h-100">
            <li class="comm-icon-rtl"><back-button  v-on:click.native="handleBackNavigation(false)"></back-button></li>
            <li class="breadcrumb-item active-text-nav-bar" aria-current="page">{{displayKeyName}}</li>
            </ol>
        </nav>
      </div>
    </div>
    <div class="set-height-of-div">
    <table class="table users-basic-info-table" style="background: transparent">
      <thead style="color: #eee">
        <tr>
          <th scope="col" style="width: 20%"></th>
          <th scope="col" style="width: 80%"></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="key-div">{{$t('Name')}} *</td>
          <td class="value-div d-inline-flex float-left m-0" style="width:100% !important">
            <div style="display:inline-grid;min-width:100%">
              <div style="display:inline-flex;width:42%;margin-inline-start: 13px;">
            <div class="w-100">
              <div class="d-inline-flex">
                <span v-show="!isMainEditting('name')" style="padding-inline-start: 0px !important;">{{displayKeyName}}</span>
                <edit-icon @click.native="editMainField('name')"
                      v-show="!isMainEditting('name')" class="editIcon">
                </edit-icon>
              </div>          
              <input type="text" id="name" v-show="isMainEditting('name')"
               class="rounded text-light comm-input-field-style align-input-field"
               autocomplete="off"  v-model="postInfo.name"
               />
            </div>
            <div v-show="isMainEditting('name')">
              <div class="d-flex">
                <save-icon @click.native="updateCustomMetadata('name')"></save-icon>
                <cancel-icon @click.native="mainFieldKeyName ='';refreshPage=false"></cancel-icon>
              </div>
            </div>
          </div>
            <div v-if="'language_alias_mapper' in keyInfo && keyInfo.language_alias_mapper && keyInfo['language_alias_mapper'].length > 0" class="main-wrapper" style="display: inline-flex; padding-top: 10px; color: rgb(163, 163, 163); flex-wrap: wrap;">
              <div v-for="(eachLang,index) in keyInfo.language_alias_mapper" :key="eachLang._id" class="each-lang" style="display: inline-flex; margin-inline-end: 3px; margin-bottom: 8px;">
                <span class="key-div">{{ 'In ' + eachLang.name + ' :' }}</span>
                <div class="ellipsis-to-entry">{{ eachLang.field_alias }}</div>
                <span v-if="index < (keyInfo.language_alias_mapper.length - 1)" style="padding-inline-start: 1px;">, </span>
              </div>
            </div>
            <button class="add-to-lang-dict-styles" @click="addLangDict()">
              Add to Language Mapper
            </button>
            </div>
          </td>
        </tr>
        <tr>
          <td class="key-div">Type *</td>
          <td class="value-div d-flex m-0">
            <div class="w-100 d-inline-flex">
              <div class="d-inline-flex">
                <span v-show="keyInfo.type == 'FREETEXT'">Plaintext</span>
                <span v-show="keyInfo.type == 'FREETEXT_MULTILINE'">Plaintext Multiline</span>
                <span v-show="keyInfo.type == 'DATE'">Date</span>
                <span v-show="keyInfo.type == 'INTEGER'">Integer</span>
                <span v-show="keyInfo.type == 'PICKLIST'">Picklist</span>
                <span v-show="keyInfo.type == 'PICKLIST_MULTIVALUE'">Picklist Multivalue</span>
              </div>  
              <div class="config-desc" style="font-size:12px;position: relative;top: 5px;">({{$t('non editable')}})</div>  
            </div>
          </td>
        </tr>
        <template v-if="['PICKLIST_MULTIVALUE','PICKLIST'].includes(keyInfo.type)">
          <tr>
            <td class="key-div p-2 align-top">{{$t('Values')}} *</td>
            <td class="value-div d-flex m-0 p-2 w-50">
              <div style="display: flex;">
                <div class="col-md-12 rounded p-0" id="values" style="height: auto;">
                  <ul class="p-0 m-0 active-tag lists-display-ul" :class="{applyBorderOnScroll:multiValueList.length>5}">
                    <li @click="checkNewValueVisibility()" class='add-new-lists-styles'>
                      <div style="margin-inline-end: 5px;position: relative;top: -2px;">
                          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" fill="currentColor" class="bi bi-plus-lg" viewBox="0 0 16 16">
                            <path d="M8 0a1 1 0 0 1 1 1v6h6a1 1 0 1 1 0 2H9v6a1 1 0 1 1-2 0V9H1a1 1 0 0 1 0-2h6V1a1 1 0 0 1 1-1z"/>
                          </svg>
                        </div>
                        <div style="font-size: 14px;">{{$t('Add picklist values')}}</div>
                    </li>
                    <template v-for="(op, index) in multiValueList">
                      <li id="tag_field" v-if="op.value.trim().length > 0" class='view-lists'  :key="index" style="margin-inline-start: 10px !important;">
                        <div class="w-100">
                          <div class="d-inline-flex">
                            <span v-show="!isEditting(index)">{{op.value}}</span>
                            <edit-icon @click.native="editValueNameField(index, op.value)"
                              v-show="!isEditting(index)" class="edit-value-icon show-tags-delete">
                            </edit-icon>
                            <div class="show-tags-delete" v-show="!isEditting(index)" 
                              @click="removeValueFromList(index, op)" >
                              <svg width="16" height="16" viewBox="0 0 16 16" class="bi bi-trash-fill" style="margin-inline-end: 8px" fill="#c5c0c0" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5a.5.5 0 0 0-1 0v7a.5.5 0 0 0 1 0v-7z"/>
                              </svg>
                            </div>
                          </div>
                          <input
                          minlength="3"
                          type="text"
                          v-model="editedValue"
                          v-show="isEditting(index)"
                          :ref="index"
                          class="rounded text-light comm-input-field-style align-input-field"
                          style="padding-inline-start: 7.4px;"
                          required
                          />
                        </div>
                        <div v-show="isEditting(index)">
                          <div class="d-flex">
                            <save-icon @click.native="updateSeletedValue(index)"></save-icon>
                            <cancel-icon @click.native="selectedValueIndex = -1;refreshPage=false"></cancel-icon>
                          </div>
                        </div>
                      </li>
                    </template>
                  </ul>
                </div>
              </div>
            </td>
          </tr>
        </template>
        <tr>
          <td class="key-div p-2 align-middle" style="width:20%;vertical-align:top !important">{{$t('Child Field')}}</td>
          <td class="value-div d-inline-block m-0 p-2" style="width:80%;float:inline-start;padding-inline-start:25px !important">
            <!-- <div class="d-inline-flex w-25 pb-2">
              <input id="fieldTypeRoot" type="radio"  value="root" v-model="typeOfField" @change="updateTypeForField('root'),typeOfField='root'" class="bg-transparent border rounded text-light bigger-checkboxes" name="type of field"/>
              <label for="fieldTypeRoot" style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Root')}}</label>
            </div>
            <div style="display:grid">
              <div class="d-inline-flex w-25">
                <input id="root" type="radio"  value="parent" v-model="typeOfField"  @change="updateTypeForField('parent'), typeOfField='parent'" class="bg-transparent border rounded text-light bigger-checkboxes" name="type of field"/>
                <label for="root" style="position: relative;bottom: 1px;inset-inline-start:5px">{{$t('Parent')}}</label>
              </div>
            </div> -->
            <div class="custom-control custom-switch">
              <input
                v-on:click="isChildField"
                type="checkbox"
                class="custom-control-input"
                id="childField"
                :checked='isChildField'
                @change="updateTypeForField"
              />
              <label class="custom-control-label" for="childField"></label> 
            </div>
            <label class="key-div" style="text-align: start;margin-bottom:0px !important">{{ $t('On enabling Child Field, a field will be added as a child field for the selected parent field') }}.</label>
          </td>    
        </tr>
        <tr v-if="isChildField">
          <td class="key-div p-2 align-middle" style="width:20%;vertical-align: top !important;">{{$t('Parent Fields')}}</td>
          <td class="value-div d-inline-block m-0 p-2 parent-fields-wrapper" style="width:80%;float:inline-start;vertical-align: top !important;">
            
            <div class="d-inline-flex w-100" style="margin-inline-start: 13px;">
              <div class="">
                <div v-if="!isMainEditting('load_when')" class="d-inline-flex">
                  <div>
                    <!-- <div v-if="keyInfo.parent_field_id_list.length > 0">
                    
                      <template v-for="(fieldObj, index) in keyInfo.parent_id_name_mapper">
                          <span :key="fieldObj._id"  style="padding-inline-start: 0px !important;">{{fieldObj.name}} {{index < (keyInfo.parent_id_name_mapper.length - 1)? ',':''}} </span>
                        </template>
                    </div>   -->
                      <span v-if="keyInfo.load_when.length > 0"  style="padding-inline-start: 0px !important;">{{keyInfo.load_when[0].name}} </span>
                      <span v-else class="empty-field-text-styles">NONE</span>
                      <div v-if="valueOfSelectedParentField && Object.keys(valueOfSelectedParentField).length>0" style="margin:10px 0px 4px 0px;display:inline-flex;width:100%;">
                        <span class="key-div" style="padding-inline-start: 3px !important;"> {{$t('Value is')}} : </span>
                        <span style="white-space: pre-wrap;padding-inline-start: 5px;">{{ showParentFieldValue() }}</span>
                      </div>
                </div> 
                  </div>
                  <edit-icon @click.native="editMainField('load_when')" v-show="!isMainEditting('load_when')" class="editIcon show-tags-delete">
                  </edit-icon>
                <Multiselect
                  v-if="isMainEditting('load_when')"
                  id="fieldNameField"
                  v-model="parentField" 
                  :options="parentFieldOptions"
                  label="name"
                  track-by="_id"
                  :close-on-select="true"
                  :multiple=false
                  :show-no-results="true"
                  deselectLabel =""
                  selectLabel=""
                  selectedLabel=""
                  :placeholder="$t('Enter field name')"
                  :hideSelected="false"
                  :showNoOptions="false"
                  @open="getFieldsFromServer"
                  @search-change="getusersOnKeyup($event)"
                  @select="userTypeOnSelect($event)"
                  >
                  <span slot="noResult">No results.</span>
                </Multiselect>
                <div v-if="valueOfSelectedParentField && Object.keys(valueOfSelectedParentField).length>0 && isMainEditting('load_when')" style="margin:10px 0px 4px 0px;display:inline-flex;width:100%;">
                  <span class="key-div" style="padding-inline-start:3px !important"> {{$t('Value is')}} : </span>
                  <span style="white-space: pre-wrap;padding-inline-start: 5px;">{{ showParentFieldValue() }}</span>
                </div>
                <div v-if="isParentFieldChanged && isMainEditting('load_when')" style="color: #fd5c5c;font-size: 13px;">
                  <span style="color:red;padding-inline-start:3px !important">{{ $t('Given Value is mismatching with selected Parent Field') }}</span>
                </div>
                <div v-if="isMainEditting('load_when')">
                  <button class="add-to-lang-dict-styles" @click="addExpressionvalue()" style="padding-inline-start:3px !important;padding-inline-end:10px">
                    {{$t('Add value to Parent field')}}
                  </button>
                  <span @click="resetParentValue()" style="    padding-inline-start: 0px !important;position: relative;bottom: 3px;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
                      <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
                      <title>Reset</title>
                    </svg>
                  </span>
                </div>  
              </div>
              <div v-show="isMainEditting('load_when')">
                <div class="d-flex" style="align-items: start;height: 100%;top: 8px;position: relative;">
                  <save-icon @click.native="updateCustomMetadata('load_when')"></save-icon>
                  <cancel-icon @click.native="mainFieldKeyName ='';refreshPage=false"></cancel-icon>
                </div>
              </div>
            </div>  
          </td>    
        </tr>
        <tr>
          <td class="key-div">{{$t('System defined')}}</td>
          <td class="value-div m-0" style="display: inline-block;width:100%;">
            <div class="w-100 d-inline-flex" style="padding-inline-start:12px;">
              <div class="d-inline-flex" disabled style="opacity: 0.7;">
                <!-- <span v-show="keyInfo.definition_type == 'user-defined'">{{$t('User Defined')}}</span>
                <span v-show="keyInfo.definition_type == 'system-defined'">{{$t('System Defined')}}</span> -->
                <div class="custom-control custom-switch">
                  <input
                    v-on:click="isSystemDefinedField"
                    type="checkbox"
                    class="custom-control-input"
                    id="systemDefined"
                    :checked='isSystemDefinedField'
                    disabled
                  />
                  <label class="custom-control-label" for="systemDefined"></label>
                </div>
            </div>  
              <div class="config-desc" style="font-size:12px;position: relative;top: 5px;">({{$t('non editable')}})</div>  
            </div>
            <label class="key-div" style="text-align: start;margin-bottom:0px !important;padding-inline-start:12px;">{{ $t('On making field as system-defined, system will generates the value for this field and it cannot be changed by user') }}.</label>
          </td>
        </tr>

        <tr style="#bbb">
          <td class="key-div p-2 align-top">{{$t('Semantic Field Category')}}</td>
          <td class="value-div d-inline-block float-left m-0" style="width:100% !important">
            <div class="d-inline-flex w-100" style="margin-left: 13px;width: 32% !important">
            <div class="w-100">
              <div class="d-inline-flex">
                <div v-show="!isMainEditting('field_category')">
                  <span v-if="selectedFieldCategory != undefined && selectedFieldCategory.id.trim().length > 0" style="padding-left: 0px !important;">{{selectedFieldCategory.label}}</span>
                  <span v-else class="empty-field-text-styles">NONE</span>
                </div>
                <edit-icon @click.native="editMainField('field_category')"
                      v-show="!isMainEditting('field_category')" class="editIcon show-tags-delete">
                </edit-icon>
                <Multiselect v-if="isMainEditting('field_category')"
                  v-model="selectedFieldCategory"
                  :options="fieldCategories"
                  :searchable="false"
                  :close-on-select="true"
                  :allow-empty="false"
                  label="label"
                  deselectLabel=""
                  selectLabel=""
                  selectedLabel=""
                  :placeholder="$t('Select Category')"
                  track-by="id">
                  <div style="display:flex;max-height:12px;align-items:center;" class="checkbox-label" slot="option" slot-scope="scope">
                    <span style="margin-left:12px;">{{ scope.option.label }}</span>
                  </div>
                </Multiselect>
              </div>
               </div>
            <div v-show="isMainEditting('field_category')">
              <div class="d-flex" style="height: 100%;align-items: center;">
                <save-icon @click.native="updateCustomMetadata('field_category')"></save-icon>
                <cancel-icon @click.native="mainFieldKeyName ='';refreshPage=false"></cancel-icon>
              </div>
            </div>
            </div>
            <div class="config-desc">
              {{$t('Select a category to help Semantic Search understand the type of information stored in this field and match user queries more accurately')}}.
            </div>
            </td>
        </tr>
        <tr>
          <td class="key-div">{{$t('Short Key')}}</td>
          <td class="value-div d-inline-block float-left m-0">
            <div class="d-inline-flex w-100" style="margin-inline-start: 13px;">
            <div class="w-100">
              <div class="d-inline-flex">
                <div v-show="!isMainEditting('short_key')">
                  <span v-if="keyInfo.short_key != undefined && keyInfo.short_key.trim().length > 0" style="padding-inline-start: 0px !important;">{{keyInfo.short_key}}</span>
                  <span v-else class="empty-field-text-styles">NONE</span>
                </div>
                <edit-icon @click.native="editMainField('short_key')" v-show="!isMainEditting('short_key')" class="editIcon show-tags-delete">
                </edit-icon>
              </div>          
              <input type="text" id="short_key" v-show="isMainEditting('short_key')"
               class="rounded text-light comm-input-field-style align-input-field"
               autocomplete="off"  v-model="postInfo.short_key"
               />
            </div>
            <div v-show="isMainEditting('short_key')">
              <div class="d-flex">
                <save-icon @click.native="updateCustomMetadata('short_key')"></save-icon>
                <cancel-icon @click.native="mainFieldKeyName ='';refreshPage=false"></cancel-icon>
              </div>
            </div>
            </div>
            <div class="config-desc">
              Short key mentioned on file name for extraction.
            </div>
          </td>
        </tr>
        <tr style="#bbb">
          <td class="key-div p-2 align-top">{{$t('About Field')}}</td>
          <td class="value-div d-inline-block float-left m-0">
            <div class="d-inline-flex w-100" style="margin-inline-start: 13px;">
            <div class="w-100">
              <div class="d-inline-flex">
                <div v-show="!isMainEditting('about_field')">
                  <span v-if="keyInfo.about_field != undefined && keyInfo.about_field.trim().length > 0" style="padding-inline-start: 0px !important;">{{keyInfo.about_field}}</span>
                  <span v-else class="empty-field-text-styles">NONE</span>
                </div>
                <edit-icon @click.native="editMainField('about_field')"
                      v-show="!isMainEditting('about_field')" class="editIcon show-tags-delete">
                </edit-icon>
              </div>
               <input type="text" v-show="isMainEditting('about_field')"
               class="rounded text-light comm-input-field-style align-input-field"
               autocomplete="off"  v-model="postInfo.about_field"
               />
               </div>
            <div v-show="isMainEditting('about_field')">
              <div class="d-flex">
                <save-icon @click.native="updateCustomMetadata('about_field')"></save-icon>
                <cancel-icon @click.native="mainFieldKeyName ='';refreshPage=false"></cancel-icon>
              </div>
            </div>
            </div>
            <div class="config-desc">
              Short description about the field.
            </div>
            </td>
        </tr>
        <!-- <tr style="#bbb">
          <td class="key-div p-2 align-middle" style="width:20%">Add to Screen</td>
          <td class="value-div d-flex m-0 p-2" style="width:80%;">
            <div style="display: inline-flex;">
              <ul class="tags-display-ul active-tag"
               style="width: 330px;
                      border: 1px solid #3a3a3a!important;
                      height: 85px;
                      margin-inline-end: 10px;">
                <li id="tag_field" class='view-lists' v-for="screenId in selectedScreenIdList" :key="screenId">
                  <div class="w-100">
                    <div class="d-inline-flex">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-layout-text-sidebar-reverse" viewBox="0 0 16 16">
                        <path d="M12.5 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm0 3a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5zm.5 3.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 .5-.5zm-.5 2.5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1h5z"/>
                        <path d="M16 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2zM4 1v14H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h2zm1 0h9a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5V1z"/>
                      </svg>
                      <span>{{getScreenIdName(screenId)}}</span>
                      <cancel-icon class="show-tags-delete" @click.native="toggleSelectedScreensInList(screenId)"></cancel-icon>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="d-flex">
                <button @click="enableScreenBrowser=true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="42" fill="currentColor" class="bi bi-plus" viewBox="0 0 16 26">
                    <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                  </svg>
                </button>
              </div>
            </div>
          </td>
        </tr> -->
      </tbody>
    </table>
    </div>
    </div>
    <add-multi-value v-show="isNewValModelVisible" @close="handleSubMultiValueClose">
    </add-multi-value>
    <browse-screens v-if="enableScreenBrowser" @close="closeScreenBrowser" :selectedScreenFieldIds="selectedScreenIdList"></browse-screens>
    <LanguageMapper v-if="enableLanguageMapperDialog"  :newField="false" :selectedFieldID="keyInfo._id" :selectedFieldResp="keyInfo" :profileName="keyInfo.name" @close="enableLanguageMapperDialog=false"></LanguageMapper>
    <FieldExpression v-if="enableExpressionValueDialog" 
      :selectedParentField="parentField" 
      @closeFeildExpressionModel="enableExpressionValueDialog=false" 
      :parentFieldOptionsList="parentFieldOptions" 
      :isExpressionEditContext="isExpressionEditContext" 
      :newField="true" 
      @addedExpressionDict="addParentFieldExpression"
      @selectedParentElement="selectedParentElementObj"
      :beforeAddedValues="valueOfSelectedParentField"></FieldExpression>
  </div>
</template>


<script>
import { mapActions,mapGetters,mapMutations } from "vuex";
import Utils from "../../components.utils.js";
import AddMultiValue from "./AddMultiValue.vue"
import EditIcon from "../core/InlineEditField.vue";
import SaveIcon from "../core/InlineSaveField.vue";
import CancelIcon from "../core/InlineCancelField.vue";
import BackButton from "../core/backButton.vue";
import BrowseScreens from "../screens/BrowseScreens.vue"
import {NotifierConstants} from "../../components.constants.js";
import LanguageMapper from "./LanguageFieldValueMapper.vue";
import Multiselect from 'vue-multiselect';
import FieldExpression from "./ParentFieldExpressionMapper.vue";
 
export default {
  components:{
    "add-multi-value": AddMultiValue,
    "edit-icon": EditIcon,
    "save-icon": SaveIcon,
    "cancel-icon": CancelIcon,
    "back-button":BackButton,
    "browse-screens":BrowseScreens,
    LanguageMapper,
    "Multiselect":Multiselect,
    FieldExpression,
  },
  data() {
    return {
      refreshPage:false,
      selectedScreenIdList:[],
      enableScreenBrowser:false,
      screensInfo:[],
      selectedValueIndex:-1,
      isNewValModelVisible:false,
      keyInfo: {},
      postInfo:{},
      multiValueList:[],
      mainFieldKeyName:"",
      selectedComponent: null,
      selectedPluginInfo:null,
      pluginsData: [],
      selectedId:"",
      fieldMultiValues:[],
      editedValue:"",
      enableLanguageMapperDialog:false,
      displayKeyName:"",
      // typeOfField:'root',
      isChildField:false,
      parentField: {},
      parentFieldOptions: [],
      parentFieldsList:[],
      selectedParentfield:{},
      selectedUserIdNameMap:{},
      isSystemDefinedField:false,
      valueOfSelectedParentField:{},
      enableExpressionValueDialog:false,
      isParentFieldChanged:false,
      isExpressionEditContext:false,
      selectedFieldCategory:{label:"NONE",id:""},
      fieldCategories:[
        {label:"NONE",id:""},
        {label:"Person",id:"person"},
        {label:"Place",id:"place"},
        {label:"Date",id:"date"},
        {label:"Number",id:"number"},
        {label:"Technical",id:"technical"},
        {label:"Other",id:"other"}
      ]
    };
  },
  props: ["selectedCustomMetadataId","selectedCustomKeyName"],
  methods: {
    getReadableLangMapper(){
      let displayText = []
      if('language_alias_mapper' in this.keyInfo && this.keyInfo.language_alias_mapper && this.keyInfo.language_alias_mapper.length > 0){
        for(let eachLang of this.keyInfo.language_alias_mapper){
          displayText.push(`In ${eachLang['name']} : ${eachLang['field_alias']}`)
        }
      }
      return displayText.join(", ")
    },
    addLangDict(){
      if(!('name' in this.keyInfo) || !this.keyInfo.name || this.keyInfo.name.trim() <= 0 ||
      !('name' in this.postInfo) || !this.postInfo.name || this.postInfo.name.trim() <= 0){
        alert("Please add valid field name.")
        this.enableLanguageMapperDialog = false
        return
      }
      this.enableLanguageMapperDialog = true;
    },
    updateSeletedValue(valueIndex){
      if(typeof this.editedValue == "undefined" || this.editedValue.trim().length <= 0){
        alert("Empty value is not supported.\nPlease enter valid value.")
        return;
      }
      let valEntry = this.fieldMultiValues.filter(op=>op.value==this.editedValue.trim())
      let valIndex = this.fieldMultiValues.findIndex(op=>op.value==this.editedValue.trim());
      if(valEntry.length > 0 && valueIndex !=valIndex){
        alert("' " + this.editedValue.trim() + " ' value is already exists. Please add different value.")
        return;
      }
      let valInfo = {
        "value":this.editedValue,
        "value_id":this.fieldMultiValues[valueIndex]['value_id']
      }
      this.multiValueList[valueIndex] = valInfo
      this.updateCustomMetadata('values')
      this.cancelSelectedValue()
    },
    changeToSelectedCustomMetadataTableComponent(compName, payload = {}){
        this.$emit("changeToSelectedCustomMetadataTableComponent", compName, payload)
    },
    cancelSelectedValue(){
      this.editedValue = ""
      this.selectedValueIndex = -1
    },
    handleBackNavigation(forceExit){
      let exitPage = true;
      if(!forceExit){
        if(this.selectedValueIndex != -1 || (this.mainFieldKeyName != undefined && this.mainFieldKeyName.length > 0)){
          if(!confirm(
                `Unsaved data exists.\nYou will loose the edited data if exit from the page.`
              )){
              exitPage = false
            }
        }
      }
      if(exitPage){
        this.selectedId = ""
        this.changeToSelectedCustomMetadataTableComponent('show-custom-metadatas')
      }
    },
    handleSubMultiValueClose(valuesList = []){
      if(valuesList.length > 0){
        let listUpdated = false;
        for(let val of valuesList){
          if(val.trim().length > 0){
            let valIndex = this.multiValueList.findIndex(op=>op.value==val.trim());
            if(valIndex < 0){
              this.multiValueList.push({"value":val.trim()})
              listUpdated = true;
            }
          }
        }
        if(listUpdated){
          this.updateCustomMetadata('values')
        }
      }
      this.isNewValModelVisible = false;
      this.$refs.fadeWhenModelOpen.style.opacity = 1;
    },
    checkNewValueVisibility(){
      this.isNewValModelVisible = true;
      this.$refs.fadeWhenModelOpen.style.opacity = 0.2;
    },
    setFocusToInputField(index){
      this.$nextTick(() => {
        const editIconRef = this.$refs[index];
        editIconRef[0].focus();
      });
    },
    editValueNameField(valueIndex, valueName) {
      this.mainFieldKeyName = ''
      this.editedValue = valueName;
      this.selectedValueIndex = valueIndex
      this.setFocusToInputField(valueIndex)
    },
    editMainField(fieldKey){
      this.cancelSelectedValue()
      this.mainFieldKeyName = fieldKey
    },
    isEditting(valueIndex) {
      return valueIndex === this.selectedValueIndex;
    },
    isMainEditting(fieldKey){
      return fieldKey == this.mainFieldKeyName;
    },
    removeValueFromList(valueIndex,option){
      console.log("this.multiValueList[valueIndex]",Object.keys(option))
      let payload = {params:{value:option.value_id,_id:this.selectedCustomMetadataId}};
      this.isCustomMetadataAttachedToAnyAsset(payload).then((data)=>{
        if(data.statusCode==200 && data.asset_tagged){
          alert(`Selected value "${option.value}" is in use.\nPlease unset and proceed for delete.`);
          return;
        }
        this.multiValueList.splice(valueIndex, 1);
        this.updateCustomMetadata('values')
      });
    },
    updateCustomMetadata(field) {
      let payload = {};
      if(field == 'values'){
        payload[field] = this.multiValueList
      }else if(field == "load_when"){
        if(this.isParentFieldChanged){
          alert("The given value of parent field is mismatching with currently selected Parent field");
          return false;
        }
        if(this.isChildField){
          // payload[field] = [this.parentField._id]
          if(this.parentField && Object.keys(this.parentField).length >0){
            let fieldIdsList = [];
                let parentFieldValueObj = null;
                if(this.parentField.type == 'FREETEXT' || this.parentField.type == 'INTEGER' || this.parentField.type == 'FREETEXT_MULTILINE'){
                  parentFieldValueObj = this.valueOfSelectedParentField.value;
                }else if(this.parentField.type == 'PICKLIST_MULTIVALUE'){
                  let selectedValueLIst = [];
                  for(let i=0;i<this.valueOfSelectedParentField.length;i++){
                    selectedValueLIst.push(this.valueOfSelectedParentField[i]._id)
                  }
                  parentFieldValueObj = selectedValueLIst;
                }else if(this.parentField.type == 'PICKLIST'){
                  parentFieldValueObj = (Object.keys(this.valueOfSelectedParentField).length>0 && '_id' in this.valueOfSelectedParentField)?[this.valueOfSelectedParentField._id]:[];
                }  
                let parentFieldObj = {};
                parentFieldObj["id"] = this.parentField._id;
                parentFieldObj["type"] = this.parentField.type;
                parentFieldObj["value"] = parentFieldValueObj && parentFieldValueObj!= null?parentFieldValueObj:[];
                
                if(Object.keys(parentFieldObj).length>0){
                  fieldIdsList.push(parentFieldObj);
                }
            payload["load_when"] = fieldIdsList;
          }

        }else{
          payload[field] = [];
        }
        // if(this.parentField.length >0){
        //   payload[field] = [this.parentField._id]
        // }else{
        //   payload[field] = this.parentField
        // }  
      }else if(field == 'field_category'){
        payload[field] = this.selectedFieldCategory.id
      }else{
        payload[field] = this.postInfo[field]
      }
      if(field == 'name'){
        if(this.postInfo[field].trim().length <= 0){
          alert("Please add valid field name.")
          return
        }
        if(!('language_alias_mapper' in this.keyInfo)){
          payload["language_alias_mapper"] = []
        }else{
          payload["language_alias_mapper"] = this.keyInfo.language_alias_mapper
        }
        //if user-preffered lang is not English then add field name to the mapper
        if(this.$i18n && this.$i18n.locale && this.$i18n.locale != 'en'){
          let langIndx = payload['language_alias_mapper'].findIndex(op=>op.code == this.$i18n.locale)
          if(langIndx >= 0){
            console.log(`Field with language ${this.$i18n.locale} Mapper added by users mannualy. Hence auto save is skipped, Only updating the alias value.`);
            this.$set(payload.language_alias_mapper[langIndx], "field_alias",payload.name.trim())
          }else{
            console.log(`Field with language ${this.$i18n.locale} Mapper not found in payload. Hence saving automatically.`);
            payload['language_alias_mapper'].push({"field_alias": payload.name.trim(),
                                                        "id": this.$i18n.locale,
                                                        "uuid": Utils.getUUID(),
                                                        "name": this.$i18n.locale_name,
                                                        "code":this.$i18n.locale})
          }
        }
      }
      payload._id = this.selectedId
      payload.params = { _id: this.selectedId };
      this.updateExistingCustomMetadata(payload).then((data) => {
        if (Utils.isAcceptedStatusCode(data.statusCode)){
          this.$toast.success(data.message);
          if(field == 'values'){
            this.multiValueList = payload[field];
            Object.assign(this.fieldMultiValues,payload[field])
          }else{
              this.keyInfo[field] = payload[field];
              if(field == 'name'){
                this.displayKeyName = payload['name']
              }
          }
          this.mainFieldKeyName =''
        } else {
          this.$toast.error(data.message);
        }
      });
      if(this.refreshPage){
        this.reloadFieldInfo();
      }
    },
    closeDialog(){
        this.selectedPluginInfo = null;
        this.selectedComponent = null
    },
    closeScreenBrowser(screenIds){
      let i= 0;
      let screensList = [];
      if(screenIds.length > 0){
        while(i <screenIds.length){
          if(screensList.indexOf(screenIds[i]) < 0){
            screensList.push(screenIds[i]);
          }
          i++
        }
      }
      Object.assign(this.selectedScreenIdList, screensList);
      this.enableScreenBrowser = false;
      this.updateScreen();
    },
    updateScreen(){
      if(typeof this.selectedScreenIdList == "undefined"){
        this.selectedScreenIdList =[];
      }
      for(let i=0;i<this.selectedScreenIdList.length; i++){
        let payload = {};
        if(typeof this.selectedId == "undefined"){
          payload["field_id_list"] = [];
        }else{
          let fieldsIdList = [];
          fieldsIdList.push(this.selectedId);
          payload["field_id_list"] = this.fieldsList;
        }
        payload._id = this.selectedScreenIdList[i];
        payload.params = { _id: this.selectedScreenIdList[i] };
        this.updateExistingScreens(payload).then((data) => {
          if (Utils.isAcceptedStatusCode(data.statusCode)){
            console.log(data.message);
          } else {
            this.$toast.error(data.message);
          }
        });
      }
    },
    toggleSelectedScreensInList(screenId){
      if(this.selectedScreenIdList.includes(screenId)){
        this.selectedScreenIdList.splice(this.selectedScreenIdList.indexOf(screenId),1);
      }
      this.updateScreen();
    },
    getScreenIdName(screenId){
      let screenDetails = this.screensInfo.filter((screen)=>screen._id == screenId);
      if(typeof screenDetails != "undefined" && screenDetails.length > 0){
        return screenDetails[0].name.trim();
      }
      return "";
    },
    reloadFieldInfo(){
      let payload = {};
      payload.params = { _id: this.selectedId };
      this.getCustomMetadataInfoFromServer(payload).then((resp) => {
        this.keyInfo = resp.custom_metadata;
        if(!('language_alias_mapper' in this.keyInfo)){
          this.keyInfo["language_alias_mapper"] = []
        }
        if('load_when' in this.keyInfo && this.keyInfo.load_when.length>0){
          // this.typeOfField = 'parent';
          this.isChildField = true;
          // this.parentField = 'load_when' in this.keyInfo && this.keyInfo.load_when[0] ? this.keyInfo.load_when[0] : {};
          this.parentField = this.parentFieldsList.find((obj)=>obj._id == this.keyInfo.load_when[0].id);
          let alreadyAddedParentFieldValue = {};
          if(this.keyInfo.load_when[0].type == "FREETEXT" || this.keyInfo.load_when[0].type == "INTEGER" || this.keyInfo.load_when[0].type == "FREETEXT_MULTILINE"){
            alreadyAddedParentFieldValue["value"] = this.keyInfo.load_when[0].value;
          }else if(this.keyInfo.load_when[0].type == "PICKLIST"){
            alreadyAddedParentFieldValue["label"] = this.keyInfo.load_when[0].value_info[0].value;
            alreadyAddedParentFieldValue["_id"] = this.keyInfo.load_when[0].value_info[0].value_id;
          }else if(this.keyInfo.load_when[0].type == "PICKLIST_MULTIVALUE"){
            let valueObjs = [];
              
            for(let i=0;i<this.keyInfo.load_when.value_info[0].length;i++){
              let multiPicklistObj = {};
              multiPicklistObj["_id"] = this.keyInfo.load_when.value_info[0][i].value_id;
              multiPicklistObj["label"] = this.keyInfo.load_when.value_info[0][i].value;
              valueObjs.push(multiPicklistObj);
            }
            alreadyAddedParentFieldValue["value"] = valueObjs;

          }

          alreadyAddedParentFieldValue["type"] = this.keyInfo.load_when[0].type;
          alreadyAddedParentFieldValue["PLabel"] = this.keyInfo.load_when[0].name;
          this.valueOfSelectedParentField =  alreadyAddedParentFieldValue;
          // for(let i=0; i<this.keyInfo.parent_field_id_list.length;i++){
          //   let index = this.parentFieldOptions.findIndex(item => item._id == this.keyInfo.parent_field_id_list[i]._id);
          //   if(index > -1){
          //       this.parentFieldOptions[index].checked = true; 
          //   }
          // }  
        }

        if(this.keyInfo.definition_type == "system-defined"){
          this.isSystemDefinedField = true;
        }
        Object.assign(this.postInfo, resp.custom_metadata);
        this.selectedFieldCategory = this.fieldCategories.find(op=>op.id == resp.custom_metadata.field_category)
        if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(resp.custom_metadata.type)){
          this.multiValueList = resp.custom_metadata.values
          Object.assign(this.fieldMultiValues, resp.custom_metadata.values)
        }
        this.selectedScreenIdList = this.keyInfo.screen_id_list;
        if('language_alias_mapper' in this.keyInfo && this.keyInfo.language_alias_mapper && this.keyInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
          let mapperExists = this.keyInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
          if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
            this.displayKeyName = mapperExists.field_alias;
          }
        }else{
          this.displayKeyName = this.keyInfo.name;
        }
        this.postInfo['name'] = this.displayKeyName
        this.refreshPage = false;
      });
      this.parentFieldsList = [];
      if(Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
          Object.assign(this.parentFieldsList,this.getStartUpDataFromInCache()["custom_metadatas"]);
      }
    },
    refreshScreenInfo(){
      if(Object.keys(this.getStartUpDataFromInCache()).includes("screens")){
        this.screensInfo = this.getStartUpDataFromInCache()["screens"];
      }
    },
    handleFieldNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
      if(notification.message){
        let entry_info = notification.message
        if ([NotifierConstants.fieldModifiedNotification].includes(notification.message_type)){
          if(this.selectedId == entry_info.custom_metadata_id){
             if(this.selectedValueIndex != -1 && this.mainFieldKeyName != undefined && this.mainFieldKeyName.length > 0){
               this.refreshPage = true;
             }else{setTimeout(()=>{
                this.reloadFieldInfo();
              }, 100)
             }
          }
        }else if(NotifierConstants.fieldRemovedNotification == notification.message_type){
          if(this.selectedId != undefined &&
             this.selectedId.length > 0 &&
             this.selectedId == entry_info.custom_metadata_id){
            this.$toast.info("' " + this.keyInfo.name + " ' field is deleted by other user(s).");
            this.handleBackNavigation(true);
          }
        }
      }
    },

    getusersOnKeyup(option){
      if(typeof(option) != "undefined" && option.trim().length > 0){
        this.removeAlreadySelectedUsers(this.filteredUserGroups())
      }else if(option.length==0){
          this.removeAlreadySelectedUsers(this.parentFieldsList);
      }
    },

    filteredUserGroups(serachWord){
      if(serachWord){
        if (!this.parentFieldsList.length) {
          return [];
        }
        return this.parentFieldsList.filter((item) => {
          const userGroupName = item.name.toLowerCase();
          const searchTerm = serachWord.toLowerCase();
          return userGroupName.includes(searchTerm);
        });
      }else{
          return this.parentFieldsList;
      }
    },

    removeAlreadySelectedUsers(parentFieldsList){
        let usersInGroup = parentFieldsList;
        if(this.selectedIds != undefined && this.selectedIds.length){
            for(let j = 0; j < this.selectedIds.length; j++){
                let temp = this.selectedIds[j];
                    usersInGroup =  usersInGroup.filter(function(el){
                    return el._id != temp;
                });
            }
            this.parentFieldOptions =  usersInGroup;
        }else{
            this.parentFieldOptions = usersInGroup;
        }
    },

    getCustomMetadataName(fieldInfo){
      if('language_alias_mapper' in fieldInfo && fieldInfo.language_alias_mapper && fieldInfo.language_alias_mapper.length > 0 && this.$i18n && this.$i18n.locale){
        let mapperExists = fieldInfo.language_alias_mapper.find(op=>op.code == this.$i18n.locale)
        if(mapperExists && Object.keys(mapperExists).length > 0 && mapperExists.field_alias && mapperExists.field_alias.length > 0){
          return mapperExists.field_alias;
        }
      }
      return fieldInfo.name;
    },

    getFieldsFromServer(){
      let payload = {}
      this.getAllCustomMetadataFromServer(payload).then((data)=>{
        let fieldList = [];
        fieldList = fieldList.concat(data.custom_metadatas)
        for(let eachField of fieldList){
          eachField['name'] = this.getCustomMetadataName(eachField)
        }

        let updatedFieldList = fieldList;
        if(this.selectedCustomMetadataId){
          updatedFieldList = fieldList.filter((cm)=>cm._id != this.selectedCustomMetadataId);
        }
        this.parentFieldOptions = updatedFieldList;
      });
    },

    // getDefaultFields(){
    //   if(this.screenType && this.screenType == "ScreenProfiles"){
    //     return [{"_id":"Description", "name":"Description"},
    //             {"_id":"Catalogs","name":"Catalogs"}]
    //   }
    //   return []
    // },
    updateTypeForField(){
      this.isChildField = !this.isChildField;
      if(this.isChildField == false){
        this.parentField = {};
        this.valueOfSelectedParentField = {};
        this.updateCustomMetadata('load_when');
      }
      
    },

    showParentFieldValue(){
      let value ="";
      if(Array.isArray(this.valueOfSelectedParentField)){
        for(let i=0; i< this.valueOfSelectedParentField.length;i++){
          if(i==0){  
            value = this.valueOfSelectedParentField[i].label;
          }else{
            value = value + ", " +this.valueOfSelectedParentField[i].label; 
          }  
        }
      }else if(this.valueOfSelectedParentField.type == "FREETEXT" || this.valueOfSelectedParentField.type == 'FREETEXT_MULTILINE'){
        value = Array.isArray(this.valueOfSelectedParentField.value) && this.valueOfSelectedParentField.value.length == 0? "" : this.valueOfSelectedParentField.value;
      }else if(this.valueOfSelectedParentField.type == "PICKLIST"){
        value = this.valueOfSelectedParentField.label;
        
      }else if(this.valueOfSelectedParentField.type == "INTEGER"){
        value = this.valueOfSelectedParentField.value.from + " ~ " +this.valueOfSelectedParentField.value.to;
      }

      return value;
    },

    selectedParentElementObj(parentFieldObj){
      this.parentField = parentFieldObj;
    },
    
    addParentFieldExpression(data){
      this.valueOfSelectedParentField = data;
      if(Array.isArray(this.valueOfSelectedParentField)){
          if(this.valueOfSelectedParentField[0].PLabel != this.parentField.name){
              this.isParentFieldChanged = true;
          }else{
            this.isParentFieldChanged = false;
          }
        
      }else if(Object.keys(this.valueOfSelectedParentField).length >0){
        if(this.valueOfSelectedParentField.PLabel != this.parentField.name){
              this.isParentFieldChanged = true;
          }else{
            this.isParentFieldChanged = false;
          }
      }else if(this.valueOfSelectedParentField.type == 'FREETEXT' || this.valueOfSelectedParentField.type == 'INTEGER' || this.valueOfSelectedParentField.type == 'FREETEXT_MULTILINE'){
        if(this.valueOfSelectedParentField.PLabel != this.parentField.name){
          this.isParentFieldChanged = true;
        }else{
          this.isParentFieldChanged = false;
        }
      }
    },
    addExpressionvalue(){
      if(Object.keys(this.parentField).length == 0){
        alert("Please select Parent Field");
        return false;
      }
      if(this.parentField.type == "DATE" || this.parentField.type == "DATE_TIME"){
        alert("'Add Value to Parent Field' is not supported with 'DATE' type Field");
        return false;
      }
      
      this.enableExpressionValueDialog = true;
    },

    userTypeOnSelect(option){
      console.log(option)
      if(Array.isArray(this.valueOfSelectedParentField)){
          if(this.valueOfSelectedParentField[0].PLabel != option.name){
              this.isParentFieldChanged = true;
          }else{
            this.isParentFieldChanged = false;
          }
        
      }else if(Object.keys(this.valueOfSelectedParentField).length >0){
        if(this.valueOfSelectedParentField.PLabel != option.name){
              this.isParentFieldChanged = true;
          }else{
            this.isParentFieldChanged = false;
          }
      }else if(this.valueOfSelectedParentField.type == 'FREETEXT' || this.valueOfSelectedParentField.type == 'INTEGER' || this.valueOfSelectedParentField.type == 'FREETEXT_MULTILINE'){
        if(this.valueOfSelectedParentField.PLabel != this.parentField.name){
          this.isParentFieldChanged = true;
        }else{
          this.isParentFieldChanged = false;
        }
      }

      if(option.type == "INTEGER"){
        this.parentField.value={
          'from':0,
          'to':1
        }
      }
    },

    resetParentValue(){
      this.valueOfSelectedParentField = {};
      this.isParentFieldChanged = false;
    },
    // userTypeOnRemove(option){
    //   let index = this.parentFieldOptions.findIndex(item => item._id == option._id);
    //   if(index > -1){
    //       this.parentFieldOptions[index].checked = false; 
    //       this.parentField = this.parentField.filter(e => e._id != this.parentFieldOptions[index]._id);
    //   }
    // },
    
    // makeCheckBoxSelection(option){
    //   return this.parentField.some((op) => op._id === option._id);
    // },

    // removeSelectedOption(option){
    //   this.userTypeOnRemove(option)
    // },
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("customMetadata", ["getCustomMetadataInfoFromServer","isCustomMetadataAttachedToAnyAsset", "updateExistingCustomMetadata" ,"getAllCustomMetadataFromServer"]),
    ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    ...mapActions("screens",["updateExistingScreens"])
  },
  created() {
    this.selectedId = this.selectedCustomMetadataId;
    this.displayKeyName = this.selectedCustomKeyName;
    this.refreshScreenInfo();
    this.reloadFieldInfo();
    this.addWSEventListener({
            eventname:[NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification],
            callback:this.handleFieldNotification,
            parent:"CustomMetadataInfo"})
  },
  beforeDestroy(){
    this.removeWSEventListener({
            eventname:[NotifierConstants.fieldModifiedNotification,
            NotifierConstants.fieldRemovedNotification],
            callback:this.handleFieldNotification,
            parent:"CustomMetadataInfo"})
  }
};
</script>


<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #1a1e21;
$border-color: 1px solid #4a4a4a;
$primary-background: #1a1e21;
$secondary-background-color:#15181B;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #2b2b2b;

.empty-field-text-styles{
  color:$none-text-color;
  padding-inline-start: 0px !important;
}

.comm-input-field-style{
    background: $primary-background!important;
    width: 100% !important;
    float: inline-start;
    padding: $input-field-padding;
    border: $border-color!important;
    font-size:$input-field-and-label-font-size;
    height: $input-field-height;
}

.align-input-field{
  margin-top:-8px;
}

.users-basic-info-table {
  tbody {
    margin: 10px;
    .key-div {
      text-align: end;
      color: $dull-text-color;
    }
    .value-div {
      text-align: start;
      margin-inline-start: 10px;
      width: 42%;
      font-weight: 500;
      span{
        padding-inline-start:13px;
      }
    }
  }
}
table {
  background: transparent;
  thead {
    th {
      color: $dull-text-color;
      border-top: $table-row-border !important;
      border-bottom: $table-row-border !important;
    }
  }
  tbody {
    color: $text-color;
    td {
      border-top: $table-row-border !important;
    }
  }
}

.view-lists{
  font-size: $input-field-and-label-font-size !important;
  min-height: 24px !important;
  display: inline-flex !important;
  margin: 6px 3px !important;
  border-radius: 15px !important;
  min-width: 50px !important;
  padding: 0px !important;
  text-align: start;
  width: 98% !important;
  justify-content: start;
  padding-top: 1px !important;
  span {
    padding: 0px 8px 0px 4px !important;
    margin-inline-start: 0px !important;
    font-size: $input-field-and-label-font-size !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

.editIcon {
  margin-inline-start: 9px;
}

.lists-display-ul .show-tags-delete,.edit-value-icon{
  visibility: hidden;
}

.lists-display-ul li:hover .show-tags-delete,.edit-value-icon {
  visibility: visible;

}

.lists-display-ul{
  // max-height: 200px;
  width: 100%;
}

.applyBorderOnScroll{
  border: $border-color;
  border-radius: 5px;
  overflow: auto;
  background:$primary-background;
}

.dropdown-item{
  padding:0px !important;
  width:13px !important;
}

.show-tags-delete {
  margin-inline-start: 7px;
  margin-inline-end: 5px;
  svg{
    fill:#939393 !important;
  }
  svg:hover{
    fill: #c5c0c0 !important;
  }
}

svg{
  fill:$text-color !important;
}

.search-bar-comm-style{
  height:30px;
  position:relative;
    margin-inline-start: 2%;
    margin-top: 5px;
  input{
    border:$border-color;
    height: 25px;
    padding-inline-start: 3%;
  }
  svg{
    position: absolute;
    inset-inline-start:12px;
    top: 44%
  }
}

.btn {
  font-size: 14px !important;
  height: 100%;
}

.border {
  border: $border-color !important;
}

.custom-control-label::before {
  background-color: $primary-background;
}

.primary-btn-style {
  margin-top: 1%;
  button {
    height: 35px;
    width: 70px;
    font-size:14px;
  }
}

.validationmessage {
  color: $danger-color;
  font-size: 11px;
}


/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: $scrollbar-track-background;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: $scrollbar-thumb-background;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: $scrollbar-thumb-on-hover-background;
}
input[type="radio"] {
    outline: none !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    padding: 4px;
    border-radius: 50% !important;
    width: 20px;
    height: 20px;
}

.bigger-checkboxes{
    height: 30px;
    width: 20px;
}

input[type="checkbox"]:after {
    line-height: 1.5em;
    content: "";
    display: inline-block;
    width: 20px;
    height: 19px;
    margin-top: 0px;
    margin-inline-start: -1px;
    border: $border-color;
    border-radius: .25em;
    background: transparent;
}

input[type="checkbox"]:checked:after {
  content: "✔";
  color: $active-blue;
  position: absolute;
  font-size: 16px;
  line-height: 1;
  transition: all 0.2s;
  font-family: Helvetica, Arial, sans-serif;
  padding-inline-start: 4px;
  padding-top: 2px;
}

input[type="radio"] {
    /* background-color only for content */
    background-color:$primary-background !important;
  }
  
  /* appearance for checked radiobutton */
  input[type="radio"]:checked {
    background-color: $active-blue !important;
    //background-image: linear-gradient(to bottom, #5294ce, #3176b3) !important;
    background: radial-gradient(circle, $active-blue 40%, $primary-background 49%, $primary-background 100%) !important;
    border: 1px solid #909090 !important;

  }


table.users-basic-info-table .editIcon {
  visibility: hidden;
}
table.users-basic-info-table td.value-div:hover .editIcon {
  visibility: visible;
}

.breadcrumb{
  padding: .75rem 1rem !important;
  background: $primary-background !important;
  align-items: center;
    .active-text-nav-bar{
        color: $text-color !important;
        text-decoration: none !important
    }
    .active-text-nav-bar:last-child{
            color: $active-blue !important;
            font-size:17px;
    }
    .breadcrumb-item{
        a{
            color: $text-color;
            font-weight:600;
        }
        a:hover{
            text-decoration: underline;
        }
    }    
}

.config-desc{
  color: $dull-text-color;
}

.config-desc{
    width: 100%;
    text-align: initial;
    margin-inline-start: 11px;
}

.add-new-lists-styles{
  display: inline-flex;
  border-radius: 10px;
  margin: 0px 8px;
  justify-content: start;
  height: 27px;
  color:$add-button-text-color;
  padding: 4px 0px 0px 0px;
  svg{
    fill:$add-button-text-color !important;
  }
}

.add-new-lists-styles:hover{
  color:$add-button-text-color-hover;
  svg{
    fill:$add-button-text-color-hover !important;
  }
}

.set-height-of-div{
  height: calc(100vh - 190px);
  overflow:auto;
  position:relative;
  top:20px;
}

.add-to-lang-dict-styles{
  color:$add-button-text-color;
  text-align: start;
  padding-inline-end: 17px;
  flex-direction: column;
  padding-top:4px;
  padding-inline-start: 13px;
  svg{
    margin-inline-end: 2px;
    margin-bottom: 3px;
  }
}

.add-to-lang-dict-styles:hover{
  text-decoration: underline;
  color:$add-button-text-color-hover;
}
.ellipsis-to-entry{
  color: #9a9620;
  padding-inline-start: 4px;
}

::v-deep{

.multiselect__content-wrapper{
  display:none;
}
.multiselect__tag {
    background-color: $primary-background !important;
  }
  .multiselect__tags{
      background: $primary-background !important;
      border: $border-color !important;
  }
  .multiselect__option--highlight {
      background: $bg-color-on-hover !important;
  }
  .multiselect__content {
      background: $secondary-background-color !important;
  }
  .multiselect__input, .multiselect__single {
      background: transparent !important;
      color:$text-color;
  }
  .multiselect__input:focus{
    outline:none;
    box-shadow: none;
  }
  .multiselect__tag-icon{
     color:$text-color !important;
  }
  .multiselect__tag-icon:focus, .multiselect__tag-icon:hover {
      background: $bg-color-on-hover !important;
      color: $text-color !important;
  }
  .multiselect__tag-icon:after{
     color:$text-color !important;
     font-size: 23px;
  }
  .multiselect *{
      font-size: $input-field-and-label-font-size !important;
      font-family: "Roboto", Arial, sans-serif !important;
  }
  .multiselect__placeholder {
    padding-top: 0px;
   }
  .multiselect{
    color:$text-color !important;
    font-size: $input-field-and-label-font-size !important;
    width:331px;
    min-height: 38px;
    height: 38px;
  }
  .multiselect__option--selected{
      background: $bg-color-on-hover !important;
      color: $text-color;
  }
  .multiselect__content-wrapper{
      border: 1px solid $bg-color-on-hover !important;
      position: relative;
      display: block;
      background: transparent;
      width: 100%;
      max-height: 240px;
      overflow: auto;
      border: $secondary-border-color;
      border-top: none;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
      z-index: 50;
      -webkit-overflow-scrolling: touch;
  }
  .multiselect__select,.multiselect__current,.multiselect__option{
      line-height: 12px !important;
  }
  .multiselect--above .multiselect__content-wrapper{
     background: $secondary-background-color !important;
  }
  .multiselect__tags {
      background: $primary-background!important;
      height: $input-field-height;
      min-height: 38px;
  }

  // .parent-fields-wrapper{
  //   .multiselect{
  //     min-height: 38px !important;
  //     height:auto !important;
  //     .multiselect__tags{
  //       height:auto !important;
  //       padding: 8px 40px 8px 8px !important;
  //     }
  //     .multiselect__placeholder{
  //       margin-bottom: 0px !important;
  //     }
  //   }  
  // }

}
</style>